import { Button } from "design-system/atoms/Button"
import { ShieldCheck } from "lucide-react"
import { useWhatsappPhoneNumberRegisterMutation } from "modules/settings/hooks/whatsapp/useWhatsappPhoneNumberRegisterMutation"
import { Loading } from "modules/shared/components/Loading"
import { useTranslation } from "react-i18next"

type WhatsappNumberVerifyProps = {
  phoneId: string
}

export const WhatsappNumberVerify = ({ phoneId }: WhatsappNumberVerifyProps) => {
  const { t } = useTranslation()
  const { mutateAsync, isPending } = useWhatsappPhoneNumberRegisterMutation()

  const onClick = () => {
    mutateAsync({ phoneId })
  }

  return (
    <Button variant={"outline"} onClick={onClick} disabled={isPending}>
      {isPending ? (
        <>
          <Loading minimal />
          {t("settings.integrations.whatsapp.table.register")}
        </>
      ) : (
        <>
          <ShieldCheck size={16} />
          {t("settings.integrations.whatsapp.table.register")}
        </>
      )}
    </Button>
  )
}
